var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13476_22340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21.3266V35.3266H16.8333L28.5 46.9933V9.65995L16.8333 21.3266H7.5ZM23.8333 20.9299V35.7233L18.77 30.66H12.1667V25.9933H18.77L23.8333 20.9299ZM39 28.3266C39 24.1966 36.62 20.6499 33.1667 18.9233V37.7066C36.62 36.0033 39 32.4566 39 28.3266ZM33.1667 7.86328V12.6699C39.91 14.6766 44.8333 20.9299 44.8333 28.3266C44.8333 35.7233 39.91 41.9766 33.1667 43.9833V48.79C42.5233 46.6666 49.5 38.3133 49.5 28.3266C49.5 18.3399 42.5233 9.98661 33.1667 7.86328Z",
    fill: "#6366F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13476_22340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.328125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.864a4819a385ca168e56713ebe6acb77.svg";
export { ForwardRef as ReactComponent };